import React from 'react';
import { TileLayer, LayersControl } from 'react-leaflet';
import type { TileProps } from './useBaseMap';

interface MapLayersProps {
  tileProps: TileProps;
}

export const MapLayers: React.FC<MapLayersProps> = ({ tileProps }) => {
  return (
    <>
      {/* Main tile layer */}
      <TileLayer
        key={tileProps.url}
        url={tileProps.url}
        attribution={tileProps.attribution}
        {...(tileProps.subdomains && tileProps.subdomains.length > 0 ? { subdomains: tileProps.subdomains } : {})}
        minZoom={tileProps.minZoom}
        maxZoom={tileProps.maxZoom}
        tileSize={tileProps.tileSize}
        noWrap={tileProps.noWrap}
      />
    </>
  );
};

interface MapLayersControlProps {
  children: React.ReactNode;
}

export const MapLayersControl: React.FC<MapLayersControlProps> = ({ children }) => {
  return (
    <LayersControl position="topright">
      <LayersControl.BaseLayer checked name="OpenStreetMap">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
      </LayersControl.BaseLayer>
      
      <LayersControl.BaseLayer name="Satellite">
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution='&copy; Esri'
        />
      </LayersControl.BaseLayer>

      {children}
    </LayersControl>
  );
};
